import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function SEOArticles() {
  return (
    <section id="artigos" className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 mb-4">
            Artigos SEO
          </span>
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950">
            Guias e Artigos Hoobuy
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            Explore nossos artigos detalhados sobre Hoobuy Spreadsheet, dicas de compra, seguran&ccedil;a e muito mais.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/artigo/${article.slug}`}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200/60 cursor-pointer transition-all duration-300"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.cardExcerpt}
                </p>
                <div className="mt-4 flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                  <span>Ler artigo completo</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}